import(/* webpackMode: "eager", webpackExports: ["ConsumerIaProvider"] */ "/vercel/path0/web/components/max/ConsumerIaProvider.tsx");
